import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {WB_MetaRow, WB_MetaTagRow, WB_MetaTextRow, WB_TagRow} from "../PA.Core/PAdbSchemaRows";
import {IwbMeta} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Meta, esWB_Meta_Text, esWB_Meta_Tags, esWB_Tag
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class MetaBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Meta: WB_MetaRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Meta'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Meta = null;
    }

    get WB_Meta(): WB_MetaRow
    {
        return this.drWB_Meta;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating Meta");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Meta.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Meta)
                .then((newMetaRow: WB_MetaRow)=> {
                    newMetaRow.setDefaults()
                    self.drWB_Meta = newMetaRow;
                    //add this to all the BOs
                    self.dbContext.add(esWB_Meta, newMetaRow)

                    self.Identity.setAll(self.WB_Meta.cif.WB_Meta_ID, self.WB_Meta.cif.META_ID, self.WB_Meta.cif.META_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Meta, 'WB_Meta_ID','META_ID','META_NAME')

                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }


    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;
        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading Meta (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "Meta already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Meta.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            this.dbContext.find(esWB_Meta,  anId)
                .then((aMetaRow) => {

                    if(_.isEmpty(aMetaRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Meta = aMetaRow;
                    self.Identity.setAll(self.WB_Meta.cif.WB_Meta_ID, self.WB_Meta.cif.META_ID, self.WB_Meta.cif.META_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Meta, 'WB_Meta_ID','META_ID','META_NAME')

                    // TODO, add in additional child relationships.
                    return (self.drWB_Meta.loadRelations([esWB_Meta_Tags, esWB_Meta_Text],
                        self.LoadOptions));
                })
                .then((aMetaRow: WB_MetaRow) => {
                    var nextTasks: Promise<any>[] = []
                    _.forEach(aMetaRow.WB_MetaTagRows, (aRow: WB_MetaTagRow) => {
                        nextTasks.push(aRow.loadRelations([esWB_Tag]));
                    });

                    return Promise.all(nextTasks)
                })
                .then((aMetaRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    //-------------TAGS--------------------------------------------

    //<editor-fold desc = "Customer Product operations">

    addTag(aWB_TAG_ID: number, options: any): Promise<MetaBO> {
        var self = this;
        return new Promise<MetaBO>((resolve, error) => {

            var aTagRow: WB_MetaTagRow = undefined

            // Is the product in the product table?
            self.dbContext.find(esWB_Tag, aWB_TAG_ID)
                .then((aTagRecord: WB_TagRow) => {
                    if (_.isEmpty(aTagRecord)) {
                        // Bad Tag ID
                        resolve(self)
                        return
                    }
                    aTagRow = aTagRecord

                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Meta_Tags)

                })
                .then((aNewRow: WB_MetaTagRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_TAG_ID = aWB_TAG_ID
                    aNewRow.cif.WB_META_ID = self.drWB_Meta.cif.WB_META_ID
                    //aNewRow.WB = aTagRow
                    self.dbContext.add(esWB_Meta_Tags, aNewRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    removeTag(aWB_TAGMETAR_ID: number, options: any): Promise<MetaBO> {
        var self = this

        return new Promise<MetaBO>((resolve, error) => {

            _.forEach(self.drWB_Meta.WB_MetaTagRows, (aTagRow: WB_MetaTagRow) => {
                if (aTagRow.isActive && aTagRow.cif.WB_TAGMETAR_ID == aWB_TAGMETAR_ID) {
                    aTagRow.markDeleted()
                }
            })

            resolve(self)
        })
    }

    //</editor-fold">

    //-------------TEXTS--------------------------------------------

    addText(options? : object): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            var aMetaTextRow: WB_MetaTextRow = undefined

            self.dbContext.createRecordWithKey(esWB_Meta_Text)
                .then((aNewRow: WB_MetaTextRow) => {
                    aNewRow.setDefaults()
                    aMetaTextRow = aNewRow
                    aMetaTextRow.cif.WB_META_ID = self.drWB_Meta.cif.WB_META_ID
                    self.dbContext.add(esWB_Meta_Text, aMetaTextRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeText(aWbTextId: number, sType: string): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_Meta.WB_MetaTextRows, (aMetaTextRow: WB_MetaTextRow) => {
                if(aMetaTextRow.isActive && aMetaTextRow.cif.WB_METAT_ID == aWbTextId) {
                    aMetaTextRow.markDeleted()
                }
            })

            resolve(self)
        })
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Meta.cif.META_NAME + "(" + self.WB_Meta.cif.META_ID + ")");
        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Meta.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbMeta = <IwbMeta>self.drWB_Meta;
        this.SaveProgressProvider.start("Saving " + wbMeta.META_NAME + "(" + wbMeta.META_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Meta.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            saveFunction(esWB_Meta, self.drWB_Meta,{})
                .then((ignore) => {
                    var tasks: Promise<any>[] = []

                    tasks.push(saveFunction(esWB_Meta_Tags,
                        self.drWB_Meta.WB_MetaTagRows))
                    tasks.push(saveFunction(esWB_Meta_Text,
                        self.drWB_Meta.WB_MetaTextRows))
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })
        });
    }

    get  bIsSaved(): boolean {
        return this._bIsSaved;
    }

    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbMeta = <IwbMeta>self.drWB_Meta;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbMeta.META_NAME + "(" + wbMeta.WB_META_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the Meta

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Meta.markDeleted()

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }



    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

};
PAEnvironment.registerBusinessObjectClass( MetaBO , "MetaBO", "Meta")